import { useAuth } from "@/components/Auth";
import { Navigate, Outlet } from "react-router";


const CountyAdminRoute: React.FC = () => {
    const { currentUser } = useAuth();
    return currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "countyadmin" || currentUser?.role?.toLocaleLowerCase() === "customersupport" ? (
        <Outlet />
    ) : (
        <Navigate to="/" />
    )
}

export default CountyAdminRoute;